import { render, staticRenderFns } from "./EmailNotificationsTabSkeleton.vue?vue&type=template&id=87559e14&scoped=true"
import script from "./EmailNotificationsTabSkeleton.vue?vue&type=script&lang=js"
export * from "./EmailNotificationsTabSkeleton.vue?vue&type=script&lang=js"
import style0 from "./EmailNotificationsTabSkeleton.vue?vue&type=style&index=0&id=87559e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87559e14",
  null
  
)

export default component.exports